import { API_BASE_URL, API_ENDPOINTS } from '../config/api.config';

const getToken = () => localStorage.getItem('authToken');

/**
 * @typedef {Object} SendOwnerNotificationParams
 * @property {number|string} propertyId
 * @property {string} [propertyTitle]
 * @property {string} [ownerPhone] — fallback if DB owner phone missing
 * @property {string} [buyerPhone] — fallback if DB buyer phone missing
 */

/**
 * Notify property owner via backend SMS when buyer views contact details.
 * @param {SendOwnerNotificationParams} params
 * @returns {Promise<boolean>}
 */
export async function sendOwnerViewNotification(params) {
  console.log('[SMS Service] Notifying owner via backend API...');

  try {
    const propertyId = params.propertyId;
    if (!propertyId) {
      console.warn('[SMS Service] propertyId is required — skipping notification.');
      return false;
    }

    const token = getToken();
    if (!token) {
      console.warn('[SMS Service] Not authenticated — skipping owner notification.');
      return false;
    }

    const body = {
      property_id: Number(propertyId),
      propertyTitle: params.propertyTitle || 'Property',
    };
    if (params.ownerPhone) {
      body.ownerPhone = params.ownerPhone;
    }
    if (params.buyerPhone) {
      body.buyerPhone = params.buyerPhone;
    }

    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.SMS_SEND_OWNER_NOTIFICATION}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(body),
    });

    const responseText = await response.text();
    let data = null;
    try {
      data = responseText ? JSON.parse(responseText) : null;
    } catch {
      data = null;
    }

    if (!response.ok) {
      const msg = data?.message || responseText?.slice(0, 200) || `HTTP ${response.status}`;
      console.warn('[SMS Service] Backend notification failed:', response.status, msg);
      return false;
    }

    if (data && data.success === false) {
      console.warn('[SMS Service] Backend notification failed:', data.message);
      return false;
    }

    console.log('[SMS Service] Owner notification sent successfully');
    return true;
  } catch (error) {
    console.error('[SMS Service] Exception:', error?.message || error);
    return false;
  }
}

/**
 * @param {SendOwnerNotificationParams} params
 * @returns {Promise<boolean>}
 */
export async function sendOwnerViewNotificationMock(params) {
  console.log('[MOCK SMS] Would notify owner for property:', params.propertyId);
  await new Promise((r) => setTimeout(r, 300));
  return true;
}
